import React from 'react';
import { TableRow, TableCell, TableHead } from '@one-thd/sui-atomic-components';
export var TableHeader = function (_a) {
    var title = _a.title, showRunner = _a.showRunner;
    return (React.createElement(React.Fragment, null,
        React.createElement(TableHead, null,
            React.createElement(TableRow, null,
                React.createElement(TableCell, { width: "full", sticky: "horizontal" }, title),
                React.createElement(TableCell, { width: "full" }),
                React.createElement(TableCell, { width: "full" }),
                showRunner && React.createElement(TableCell, { width: "full" })))));
};
